import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ModalsEngineselectorPage } from './modals-engineselector';

@NgModule({
  declarations: [
    ModalsEngineselectorPage,
  ],
  imports: [
    IonicPageModule.forChild(ModalsEngineselectorPage),
  ],
})
export class ModalsEngineselectorPageModule {}



// WEBPACK FOOTER //
// ./src/pages/modals-engineselector/modals-engineselector.module.ts